import React from "react";
import { BrandLogo } from "../brand/BrandLogo";
import { Link } from "react-router-dom";
import { Facebook, Linkedin, Instagram } from "lucide-react";

const TikTok = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.6 6.7a4.8 4.8 0 0 1-3.8-4.2V2h-3.4v13.4a2.9 2.9 0 1 1-2-2.7V9.2a6.3 6.3 0 1 0 5.4 6.2V8.6a8.2 8.2 0 0 0 3.8 1.2V6.7z" />
  </svg>
);

const SOCIALS = [
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/360_immoinvest", Icon: Instagram },
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/360immoinvest.com", Icon: Facebook },
  { id: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@360_immoinvest", Icon: TikTok },
  { id: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/in/cindy-invest-01393543a", Icon: Linkedin },
];

const COLS = [
  { title: "Produit", links: ["Fonctionnalités", { label: "Tarifs", to: "/tarifs" }, "Application mobile", "Nouveautés"] },
  { title: "Ressources", links: [
    { label: "Le blog du bailleur", to: "/blog" },
    { label: "Simulateur LMNP 2027", to: "/simulateur-lmnp-2027" },
    { label: "Quittance de loyer", to: "/quittance-de-loyer" },
    { label: "Révision de loyer (IRL)", to: "/revision-loyer-irl" },
    { label: "Revenus fonciers", to: "/declaration-revenus-fonciers" },
    { label: "Gestion à distance", to: "/gestion-locative-a-distance" },
  ] },
  { title: "Entreprise", links: ["À propos", "Contact", { label: "Devenir référent", to: "/devenir-referent" }, "Partenaires"] },
  { title: "Légal", links: [
    { label: "CGU", to: "/cgu" },
    { label: "Confidentialité", to: "/politique-de-confidentialite" },
    { label: "Cookies", to: "/politique-de-cookies" },
    { label: "Gérer les cookies", cookieSettings: true },
    { label: "Mentions légales", to: "/mentions-legales" },
  ] },
];

export default function Footer() {
  return (
    <footer className="bg-brand-greenDeep text-white/80">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <BrandLogo variant="sombre" className="h-8 sm:h-9 w-auto" />
            </div>
            <p className="text-sm leading-relaxed max-w-xs">
              Le logiciel de gestion locative qui vous aide à suivre vos loyers, vos documents et vos finances. Fait en France 🇫🇷
            </p>
            <div className="flex gap-3 mt-6">
              {SOCIALS.map(({ id, label, href, Icon }) => (
                <a key={id} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={`footer-social-${id}`} className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-lime hover:text-brand-greenDeep flex items-center justify-center transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="text-white font-semibold mb-4 text-sm">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((l) => {
                  const isObj = typeof l === "object";
                  const label = isObj ? l.label : l;
                  return (
                    <li key={label}>
                      {isObj && l.cookieSettings ? (
                        <button type="button" data-cookie-settings="" className="text-sm hover:text-brand-lime transition-colors" data-testid="footer-manage-cookies">{label}</button>
                      ) : isObj && l.to ? (
                        <Link to={l.to} className="text-sm hover:text-brand-lime transition-colors" data-testid={`footer-link-${l.to.replace(/\//g, "")}`}>{label}</Link>
                      ) : (
                        <a href="#" className="text-sm hover:text-brand-lime transition-colors">{label}</a>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm">© 2026 360immoinvest.</p>
          <p className="text-sm">Fait avec soin en France 🇫🇷</p>
        </div>
      </div>
    </footer>
  );
}
